<template>
	<div class="como-hacemos">
		<h4>
			¿Que tenemos para ofrecerte?
		</h4>

		<iframe width="560" height="315"
		    src="https://www.youtube.com/watch?v=_Tcxk0wthYE"
		    title="Video de ComercioCity"
		    loading="lazy"
		    frameborder="0"
		    allowfullscreen>
		</iframe>

		
	</div>
</template>
<script>
export default {
	components: {
	},
	computed: {
	}
}
</script>
<style lang="sass">
.como-hacemos
	h4 
		font-size: 50px
		margin: 50px 0
	.cont-cards-como-hacemos
		display: flex 
		flex-direction: row 
		justify-content: center 
		align-items: center
		flex-wrap: wrap  
</style>